import React from 'react';
import { COLORS } from '../constants';
import { ZoomLevel } from '../utils/timeScale';

// Segmented Month/Day zoom toggle, styled like the toolbar's ViewTypeSwitch
// (navy active fill, white bg, rounded). Sits next to the Group-by dropdown.

type Props = {
  value: ZoomLevel;
  onChange: (next: ZoomLevel) => void;
};

const OPTIONS: { key: ZoomLevel; label: string }[] = [
  { key: 'monthly', label: 'Month' },
  { key: 'daily', label: 'Day' },
];

// Mirrors Toolbar/ViewTypeSwitch: white rounded container, each item a rounded pill,
// active = navy fill + white text, inactive = grey text.
const ZoomSwitch: React.FC<Props> = ({ value, onChange }) => (
  <div
    style={{
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      background: '#FFFFFF',
      borderRadius: 12,
      height: 24,
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.16)',
    }}
  >
    {OPTIONS.map((o) => {
      const active = value === o.key;
      return (
        <span
          key={o.key}
          role="button"
          tabIndex={0}
          onClick={() => onChange(o.key)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onChange(o.key);
          }}
          style={{
            display: 'inline-flex',
            flex: '1 1 0',
            alignItems: 'center',
            justifyContent: 'center',
            height: 24,
            padding: '0 12px',
            borderRadius: 14,
            fontSize: 13,
            lineHeight: 1,
            cursor: 'pointer',
            background: active ? COLORS.primaryText : 'transparent',
            color: active ? '#FFFFFF' : COLORS.headerSubtleText,
          }}
        >
          {o.label}
        </span>
      );
    })}
  </div>
);

export default ZoomSwitch;
